import customer_success from './customerSuccess'
import designer from './designer'
import redactor from './redactor'
import staff from './staff'
import user from './user'

export const roles = {
  customer_success,
  designer,
  redactor,
  staff,
  user,
}
